import { render, staticRenderFns } from "./ElOrdersForm.vue?vue&type=template&id=259700db&scoped=true&"
import script from "./ElOrdersForm.vue?vue&type=script&lang=js&"
export * from "./ElOrdersForm.vue?vue&type=script&lang=js&"
import style0 from "./ElOrdersForm.vue?vue&type=style&index=0&id=259700db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259700db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('259700db')) {
      api.createRecord('259700db', component.options)
    } else {
      api.reload('259700db', component.options)
    }
    module.hot.accept("./ElOrdersForm.vue?vue&type=template&id=259700db&scoped=true&", function () {
      api.rerender('259700db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/forms/ElOrdersForm.vue"
export default component.exports